import { render, staticRenderFns } from "./EditorMenu.vue?vue&type=template&id=bee258b8&"
import script from "./EditorMenu.vue?vue&type=script&lang=js&"
export * from "./EditorMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditorMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports